import script from "./CheckboxInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckboxInput.vue?vue&type=script&setup=true&lang=js"

import "./CheckboxInput.vue?vue&type=style&index=0&id=128c8506&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-128c8506"]])

export default __exports__